app.controller('uplCtrl', function ($rootScope, $scope, FileUploader, services, fctService, $location, ServiceQcm, toastr) {

    $scope.url_ = $rootScope.url_;

    var _DEBUG = 0;

    $scope.choixPAGE = 3;
    $scope.correction = 0;
    $scope.correction = 100;

    //alert(' debut du controller : socket='+$rootScope.socket)
    //alert('encore ... socket on')
    $scope.uploadencours = 0;
    /*
        if (!angular.isObject($rootScope.socket)){
            $rootScope.socket= io.connect($location.host()+$rootScope.PORT);
        }else{
            //alert("socket=fermé"+$rootScope.socket);
            $rootScope.socket=null
        }
    */
    //$rootScope.socket= io.connect();

    //////    $rootScope.socket= io.connect($location.host());

    //alert($location.host()+$rootScope.PORT)
    $scope.$watch('ppp', function (newValue, oldValue) {
        $scope.nbFichierTraite++;
    });

    $scope.init = function () {

        $rootScope.menuSelectionne = 4;

        $scope.NB_FICHIER_ENVOYE = 0;
        $scope.NB_FICHIER_A_TRAITE = 0;
        $scope.NB_FICHIER_TRAITE = 0;
        $scope.NB_FICHIER_ERREUR = 0;
        //new ServiceQcm.calculNotes($rootScope.qcmSelectionne);
        // INUTILE CAR DEJA FAIT !

        $scope.listeCopie = $rootScope.qcmSelectionne.listeCopie

        if (typeof ($rootScope.qcmSelectionne.id) == "undefined") {
            $scope.choixQCM = -1;
            $rootScope.menuSelectionne = 1;
            //document.location.href = "/#/1qcm"
            $location.path('/1qcm');//document.location.href

        }

        $scope.qcmSelectionne = $rootScope.qcmSelectionne;
        $scope.choixQCM = $rootScope.qcmSelectionne.id;

        $scope.listeFichier = new Array;
        if ($rootScope.qcmSelectionne.listeCopie.length > 0)
            $scope.listeFichier = fabriqueListeFichier($rootScope.qcmSelectionne.listeCopie)

        $scope.nbEtudiant = $rootScope.qcmSelectionne.nbEtudiant;


        //fctService.majListeCopie();
        new ServiceQcm.chargement($rootScope.qcmSelectionne).then(function (data) {
            $scope.qcmSelectionne = data
            $rootScope.qcmSelectionne = data
            $scope.choixQCM = $scope.qcmSelectionne.id
            //alert("fini")
        })
            .catch(function (response) {
                toastr.error("___session expirée___");
                $scope.loader = 0;
                $location.path('/QCMscanner');
            });



        //$scope.qcmSelectionne.moyenne = fctService.calculNotes();
        $scope.correction = 0;
        $scope.fait = 0;
        $scope.nbFichierTraite = 0;
    };
    if (typeof ($rootScope.socket) === 'undefined') { ; }
    else {
        // le client reçoit 2 types de messages :
        /*$rootScope.socket.on('S2C', function(data) {
            console.log('--S2C - socket reçue--->>>')
        })*/

    }

    // on a listeCopie, je veux listeFichier
    var fabriqueListeFichier = function (liste) {
        var listeFichier = new Array;
        var nbListeFichier = 0;
        var nb = 1;

        for (var nbC = 0; nbC < liste.length; nbC++) {

            var trouve = false;
            for (var i = 0; i < listeFichier.length && !trouve; i++) {
                if (listeFichier[i].nomFichierEnvoi == liste[nbC].fichierUpload) {
                    trouve = true;
                    //alert('trouve='+trouve)
                }
            }
            if (trouve) {
                listeFichier[i - 1].nb++;

            } else {
                nb++;
                listeFichier.push({ 'nomFichierEnvoi': liste[nbC].fichierUpload, 'idqcm': liste.id, 'nb': 1 })
            }
        }
        return listeFichier;
    };

    // TELCHARGEMENT
    var uploader = $scope.uploader = new FileUploader({
        url: '/envoi/',
        formData: [{ 'id': $rootScope.qcmSelectionne.id, 'nbQuestion': $rootScope.qcmSelectionne.nbQuestion, 'UneSeuleReponse': $rootScope.qcmSelectionne.UneSeuleReponse % 2, 'nbReponse': $rootScope.qcmSelectionne.nbReponse, 'multi_nbpage': $rootScope.qcmSelectionne.multi_nbpage, 'nbNumero': $rootScope.qcmSelectionne.nbNumero, 'typeCoin': $rootScope.qcmSelectionne.typeCoin, 'remord': $rootScope.qcmSelectionne.remord }]
    });

    var tableau = new Array;


    // FILTERS

    uploader.filters.push({
        name: 'customFilter',
        fn: function (item /*{File|FileLikeObject}*/, options) {
            return this.queue.length < 100;
        }
    });

    // CALLBACKS
    uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
        if (_DEBUG) console.info('onWhenAddingFileFailed', item, filter, options);
    };
    uploader.onAfterAddingFile = function (fileItem) {
        if (_DEBUG) console.info('onAfterAddingFile', fileItem);
    };
    uploader.onAfterAddingAll = function (addedFileItems) {
        if (_DEBUG) console.info('onAfterAddingAll', addedFileItems);
    };
    uploader.onBeforeUploadItem = function (item) {

        if ($scope.uploadencours == 0) {
            $scope.uploadencours = 1;

            $rootScope.socket = {};
            $rootScope.socket = io($location.protocol() + '://' + $location.host() + ':' + $location.port());
            //console.log('creation socket : '+ $location.protocol() + '://' + $location.host()+':'+$location.port())

            /******************************************************************************************************/
            $rootScope.socket.on('id', function (data) {
                if (_DEBUG) console.log('--socket reçue--->>> id=' + data);
                $rootScope.socketid = data;
            });
            $rootScope.socket.on('ok1', function (data) {
                i = Number(data.nb_fichier_image);
                nom = data.nom;

                $scope.listeFichier.push({ "nomFichierEnvoi": nom, "nb": i });

                //console.log("-ok1--------- :   fichier envoyé : "+i);
                $scope.NB_FICHIER_A_TRAITE = $scope.NB_FICHIER_A_TRAITE + i - 1;
                $scope.$apply();
            });
            $rootScope.socket.on('fin3', function (data) {

                //console.log("-fin3---------analyse d'une copie terminée : "+data.idcopie);
                $scope.NB_FICHIER_TRAITE++;
                $scope.$apply();

            });
            $rootScope.socket.on('erreur', function (data) {
                //console.log("-erreur1---------"+data.retour);
                $scope.NB_FICHIER_ERREUR++;
                $scope.a = data;
                $scope.$apply();

            });
            $rootScope.socket.on('erreur2', function (data) {
                //console.log("-erreur2---------"+data.retour);
                $scope.NB_FICHIER_ERREUR++;
                $scope.b = data;
                $scope.$apply();

            });
            $rootScope.socket.on('erreur3', function (data) {
                //console.log("-erreur3---------"+data.retour);
                $scope.NB_FICHIER_ERREUR++;
                $scope.c = data;
                $scope.$apply();

            });

            /******************************************************************************************************/
        }

        if ($scope.NB_FICHIER_A_TRAITE == 0) {
            $scope.NB_FICHIER_A_TRAITE = this.queue.length;//on attend AU moins le nb de fichier envoyé !
            $scope.NB_FICHIER_ERREUR = 0;
        }
        // le nom 'token' est celui définit dans le programme 'satellizer.js' dans node_modules
        item.headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };

        if (_DEBUG) console.info('onBeforeUploadItem', item);
    };
    uploader.onProgressItem = function (fileItem, progress) {
        if (_DEBUG) console.info('onProgressItem', fileItem, progress);
    };
    uploader.onProgressAll = function (progress) {
        if (_DEBUG) console.info('onProgressAll', progress);
    };
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
        if (_DEBUG) console.info('onSuccessItem', fileItem, response, status, headers);
    };
    uploader.onErrorItem = function (fileItem, response, status, headers) {
        if (_DEBUG) console.info('onErrorItem', fileItem, response, status, headers);
    };
    uploader.onCancelItem = function (fileItem, response, status, headers) {
        if (_DEBUG) console.info('onCancelItem', fileItem, response, status, headers);
    };
    uploader.onCompleteItem = function (fileItem, response, status, headers) {
        if (_DEBUG) console.info('onCompleteItem', fileItem, response, status, headers);
        $scope.correction++
    };
    uploader.onCompleteAll = function () {
        $scope.nbFichierTraite = 0;
        if (_DEBUG) console.info('**********************************************************onCompleteAll - coté client');
        this.clearQueue();
        $scope.uploadencours = 0;
        toastr.info('___Fin du traitement___');
        if ($scope.NB_FICHIER_ERREUR > 0) {
            toastr.info($scope.NB_FICHIER_A_TRAITE + " ___copies___.");
            toastr.error($scope.NB_FICHIER_ERREUR + '___erreurs___');
        } else {
            toastr.success($scope.NB_FICHIER_A_TRAITE + " ___copies___.");
        }
        //$rootScope.socket.removeAllListeners("news");
        $rootScope.socket.destroy();
        //$rootScope.socket= io.connect();
        $location.path('/4upl');


    };

    /******************************************************************************************************
        $rootScope.socket.on('ok1', function(data) {
            i=Number(data.nb_fichier_image);
            nom=data.nom;
    
            $scope.listeFichier.push({"nomFichierEnvoi":nom , "nb":i});
    
            console.log("-ok1--------- :   fichier envoyé : "+i);
            $scope.NB_FICHIER_A_TRAITE=$scope.NB_FICHIER_A_TRAITE+i-1;
            $scope.$apply();
        })
    
    ******************************************************************************************************/
    /*    $rootScope.socket.on('ok2', function(data) {
            console.log('-ok2---------copie créée - pas traitée :  et '+data.idcopie);
        })
    */
    /******************************************************************************************************/
    /******************************************************************************************************
        $rootScope.socket.on('fin3', function(data) {
    
            console.log("-fin3---------analyse d'une copie terminée : "+data.idcopie);
            $scope.NB_FICHIER_TRAITE++;
            $scope.$apply();
            
        })
    ******************************************************************************************************/
    $scope.cancel = function () { //revenir à la liste des qcm
        $location.path('/0lst');
    }
    /******************************************************************************************************/
    $scope.supprimerUpload = function (fichier) {


        new services.supprimerUpload($rootScope.qcmSelectionne.id, fichier).then(function (data) {

            //$scope.listeFichier.splice($scope.listeFichier.indexOf(fichier), 1)

            // supprimer de $scope
            if ($scope.listeFichier.length > 0) {
                for (i = $scope.listeFichier.length - 1; i >= 0; i--) {
                    //alert("lg="+$scope.listeFichier.length)
                    if ($scope.listeFichier[i].nomFichierEnvoi == fichier.nomFichierEnvoi) {
                        //alert("lg="+$scope.listeFichier.length)
                        $scope.listeFichier.splice(i, 1)
                    }
                }
            }
            if ($rootScope.qcmSelectionne.listeCopie.length > 0) {
                //alert("root (1) lg="+$scope.listeFichier.length)
                for (i = $rootScope.qcmSelectionne.listeCopie.length - 1; i >= 0; i--) {
                    if ($rootScope.qcmSelectionne.listeCopie[i].fichierUpload == fichier.nomFichierEnvoi) {
                        //alert("root (2) lg="+$scope.listeFichier.length)
                        $rootScope.qcmSelectionne.listeCopie.splice(i, 1)
                    }
                }
            }
            new ServiceQcm.chargement($rootScope.qcmSelectionne).then(function (data) {
                $scope.qcmSelectionne = data
                $rootScope.qcmSelectionne = data
                $scope.choixQCM = $scope.qcmSelectionne.id
                //alert("fini")
            })
                .catch(function (response) {
                    toastr.error("___session expirée___");
                    $scope.loader = 0;
                    $location.path('/QCMscanner');
                });
        })
            .catch(function (response) {
                toastr.error("___session expirée___");
                $scope.loader = 0;
                $location.path('/QCMscanner');
            });

    }

});




